import { render, staticRenderFns } from "./ClassRegister.vue?vue&type=template&id=667060e0&scoped=true&"
import script from "./ClassRegister.vue?vue&type=script&lang=js&"
export * from "./ClassRegister.vue?vue&type=script&lang=js&"
import style0 from "./ClassRegister.vue?vue&type=style&index=0&id=667060e0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667060e0",
  null
  
)

export default component.exports